import { iconBaseProps, type IconProps } from "@/components/ui/icons/icon-base"

export const CarIcon = ({ size = 16, ...props }: IconProps) => (
  <svg {...iconBaseProps(size, props)} fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 12l1.7-5A2 2 0 0 1 7.6 5.6h8.8a2 2 0 0 1 1.9 1.4L20 12" />
    <path d="M2.5 12h19v4a1 1 0 0 1-1 1h-1.5v-1.5H5V17H3.5a1 1 0 0 1-1-1z" />
    <path d="M7 17v.01M17 17v.01" />
  </svg>
)
